import React, { useEffect, useState } from "react";
import ModalTemplate from "../modal-template";
import styled from "styled-components";
import OTPInput from "react-otp-input";
import { Colors } from "utils/colors";
import Typography from "components/typography";
import PrimaryButton from "components/buttons/primary-button";
import { IUser } from "types/user";
import { GetUser } from "services/user/getUser";

interface IProps {
  close: () => void;
  confirm: (otp: string) => void;
  resend: () => void;
}
const VerifyEmail = ({ close, confirm, resend }: IProps) => {
  const [otp, setOtp] = useState("");
  const UserData = GetUser();

  useEffect(() => {
    if (otp.length === 6) {
      confirm(otp);
    }
  }, [otp]);

  const OtpStyle = () => {
    let style = {
      width: "6.4rem",
      backgroundColor: Colors.grey700,
      marginRight: "2rem",
      height: "6.4rem",
      border: "1px solid #4E4E4E",
      borderRadius: "0.8rem",
      color: "white",
      fontSize: "3.2rem",
      fontWeight: "600"
    };

    if (window.innerWidth <= 768) {
      style = {
        ...style,
        width: "4.8rem",
        height: "4.8rem",
        fontSize: "2.4rem",
        marginRight: "0.8rem"
      };
    }

    return style;
  };
  return (
    <ModalTemplate
      close={close}
      header="Verify Your Email Address"
      confirmText="Verify"
      confirm={() => confirm(otp)}
    >
      <Typography
        align="center"
        mb="2.4"
        weight="semibold"
        color={Colors.white300}
      >
        Please enter the 6 digit code we sent to {UserData?.email} to verify
        it’s really you
      </Typography>
      <OtpContainer>
        <OTPInput
          value={otp}
          onChange={setOtp}
          numInputs={6}
          inputStyle={OtpStyle()}
          renderInput={(props) => <input {...props} />}
        />
      </OtpContainer>
      <ResendDiv>
        <Typography mr="0.2" size="s" color={Colors.grey500}>
          Having Trouble receiving code?
        </Typography>
        <PrimaryButton
          variant="text"
          textSize="s"
          fitContent
          text="Resend Code"
          onClick={resend}
        />
      </ResendDiv>
    </ModalTemplate>
  );
};

export default VerifyEmail;

const OtpContainer = styled.div`
  width: 100%;
  margin-top: 2.4rem;
  align-items: center;
  font-family: "Switzer", sans-serif;
  justify-content: center;
  display: flex;
`;

const ResendDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2.4rem;
`;
